module.exports = __webpack_public_path__ + "img/KD.2b2ce33b.png";